/*
 * Module for the Interest Process job criteria page
 */
rs.module("content/jobs/criteria/interestprocess",

    ["common/select-helper", "common/visibility"],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, batchTypes, searchControl, backendUrls) {
            var criteria = $.js(jsSelectors.criteria);

            var batchTypeRadioContainer = criteria.js(jsSelectors.batchTypeRadioContainer);
            var individualContainer = criteria.js(jsSelectors.individualContainer);
            var statusContainer = criteria.js(jsSelectors.statusContainer);
            var planSelect = criteria.js(jsSelectors.planSelect);

            // Get Select Helpers for selects where we're updating options and properties
            var planSelectHelper = selectHelper.getHelper(planSelect);
            
            // Register click event for batch type radio buttons 
            batchTypeRadioContainer.find("input").on("click", () => onBatchTypeChanged());

            // Listen for a participant to be selected from the search control, and repopulate plans
            searchControl.onSelectionComplete(function (accountPartyKey) {
                populatePlans(accountPartyKey);
            });

            // Listen for the search control to be cleared, and repopulate plans
            searchControl.onSelectionCleared(function () {
                populatePlans();
            });

            // Batch Type has changed
            function onBatchTypeChanged() {

                // get selected batch type
                var selectedBatchType = batchTypeRadioContainer.find("input:checked").val();

                // clear the search control, which will also repopulate plans (since we're handling onSelectionCleared above)
                searchControl.clear();

                // set visibility of controls based on selected batch type
                visibility.setVisible(individualContainer, selectedBatchType == batchTypes.individual);     
                visibility.setVisible(statusContainer, selectedBatchType == batchTypes.group);    
            }

            // Populate the Plans Select (accountPartyKey is optional)
            function populatePlans(accountPartyKey) {

                // clear any plan select validation errors
                planSelect.clearErrors();

                // re-populate plans
                planSelectHelper.loadOptionsFrom(
                    backendUrls.getAvailablePlansAsync,
                    {
                        accountPartyKey: accountPartyKey
                    });         
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);